/* eslint-disable react/no-danger */
/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
import React from 'react';
import { useSelector } from 'react-redux';

import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';

import * as S from './styles';

const LoginFlashMessageNotification = () => {
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  return (
    <>
      {profile.loginStatus.show && (
        <S.FlashMessage className={`alert p-3 text-center mb-0 alert-${profile.loginStatus.class}`}>
          {profile.loginStatus.text}
        </S.FlashMessage>
      )}
    </>
  );
};

export default LoginFlashMessageNotification;
